import { memo } from "react";

import { Badge, Card, Group, Stack, Text } from "@mantine/core";
import { TbBulb } from "react-icons/tb";

import { formatDate } from "modules/core/utils/helpers";
import { insightConfidenceLevels } from "modules/insights/components/InsightCard/constants";
import { researchPrivateRoutesConstants } from "modules/research/routes/private/routesConstants";

export type DisplayObservationProps = {
  id: string;
  research_id: number;
  project_id: string;
  created_at: string;
  name: string;
  description?: string;
  confidence_level: "low" | "medium" | "high";
  is_draft: boolean;
};

const DisplayObservation = (props: DisplayObservationProps) => {
  const {
    id,
    research_id,
    project_id,
    created_at,
    name,
    description,
    confidence_level
  } = props;

  return (
    <Card
      withBorder
      shadow="xs"
      component="a"
      href={researchPrivateRoutesConstants.single_research.href(
        research_id,
        project_id,
        id
      )}
      target="_blank"
      rel="noopener noreferrer"
      radius="lg"
    >
      <Stack gap="xs">
        <Badge
          size="xs"
          color="grape"
          variant="transparent"
          tt="capitalize"
          leftSection={<TbBulb size={12} />}
        >
          Observation
        </Badge>

        <div>
          <Text size="sm" fw={600}>
            {name}
          </Text>

          {description ? (
            <Text size="xs" c="gray.6">
              {description}
            </Text>
          ) : null}
        </div>

        <Group justify="space-between">
          <Badge
            color={insightConfidenceLevels[confidence_level].color}
            size="xs"
            tt="capitalize"
            variant="light"
          >
            {insightConfidenceLevels[confidence_level].label}
          </Badge>

          <Text size="xs" c="gray.6">
            Created:{" "}
            {formatDate({
              datestring: created_at,
              dateFormat: "dd MMM yyyy"
            })}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};

export default memo(DisplayObservation);
